module.exports = __webpack_public_path__ + "9ff05e3cd89cb37752d32bb1174c8860.woff2";